import { LocationDefaults } from '../models';

export class FetchLocationDefaults {
  static readonly type = '[LocationDefaults] Set';

  constructor(public payload?: LocationDefaults) {}
}
